module.exports = __webpack_public_path__ + "img/12.6163c9e.png";